// max 24 projects
export const projects = [
  {
    id: 1,
    name: 'musik',
    description:
      'able to take youtube playlists and convert them into spotify playlists so you can enjoy your favourite songs on both platforms, easily and conveniently.',
    tech: 'python • spotify api • youtube api',
    image: './assets/icons/music_disc_4.png',
    link: 'https://github.com/',
  },
  {
    id: 2,
    name: 'breakout',
    description:
      'a personalized recreation of the game breakout, including an addition of powerups, themes, and levels.',
    tech: 'python • pygame',
    image: './assets/icons/ender_pearl.png',
    link: 'https://hajar-assim.github.io/hajarassim-portfolio/#:~:text=themes%2C%20and%20levels.-,python%20%E2%80%A2%20pygame,-mus%C3%AFk',
  },
  {
    id: 3,
    name: 'fitnesstrackr',
    description:
      'a health and fitness club management system empowering members to achieve fitness goals and monitor progress effectively.',
    tech: 'spring boot • react • postgres',
    image: './assets/icons/chainmail_boots.png',
    link: 'https://github.com/HasibKhodayar/COMP_3005_ProjectV2',
  },
  {
    id: 4,
    name: 'sysc.ca',
    description:
      'a site built with a team of other students, designed to help guide first year engineering students at carleton with resources, schedules, and the answered to FAQs',
    tech: 'react • javascript',
    image: './assets/icons/lantern.png',
    link: 'https://hajar-assim.github.io/sysc-site/',
  },
  {
    id: 5,
    name: 'firefighting drone system',
    description:
      'a real-time, distributed Java system that coordinates firefighting drones with fault tolerance and dynamic scheduling.',
    tech: 'java • swing • multi-threading',
    image: './assets/icons/campfire.png',
    link: 'https://github.com/hajar-assim/Firefighting-Drone-Swarm-Group-5',
  },
  {
    id: 5,
    name: 'lunchbox ai',
    description:
      'a lightweight computer vision system that monitors food queue lengths and notifies staff in real-time to optimize service during peak hours.',
    tech: 'python • tensorflow • opencv • slack_sdk • slack_bolt',
    image: './assets/icons/cooked_mutton.png',
    link: 'https://github.com/hajar-assim/LunchBox-AI',
  },
  {
    id: 6,
    name: 'leetcode solutions',
    description: 'please',
    tech: 'java',
    image: './assets/icons/backpack.png',
    link: 'https://github.com/hajar-assim/leetcode-sol',
  },
];
